<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Yeni Muhasebe Faturası",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
        list: {},
        title: "YENİ FATURA",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "YENİ FATURA",
            active: true,
          },
        ],
        cariList: [],
        lines:[
            {
                name:'', 
                amount:0, 
                unit:0, 
                tax:{ 
                    kdv:{
                        visible:true,
                        range:20,
                        amount:0
                    },
                    oiv:{}
                },
                total:0
            } 
        ],
        total:{ araToplam:0, tax:{} },
        isLoading: false,
        submitted:false,
        form:{
            date:new Date().toISOString().split('T')[0]
        }
    };
  },
  computed:{ },
  mounted() {},
  filters:{
    fixed(data){
        if(!data) return
        return data.toFixed(2);
    }
  },
  methods: {
    addTax(type, index){
        this.lines[index].tax[type] = { 'visible':true, 'range':0, 'amount':0 }
    },
    removeTax(type, index){
         this.lines[index].tax[type] = { 'visible':false, 'range':0, 'amount':0 }
    },
    newLine(){
        this.lines.push({
                name:'', 
                amount:0, 
                unit:0, 
                tax:{ 
                    kdv:{
                        visible:true,
                        range:20,
                        amount:0
                    },
                    oiv:{}
                },
                total:0
            })
    },
    removeLine(index){
        this.lines.splice(index, 1);
        this.toplam()
    },
    calc(index){
        const amount = this.lines[index].amount || 0
        const unit = this.lines[index].unit || 0
        let lineTotal =0;

        lineTotal = (parseFloat(amount) * parseFloat(unit))
        this.lines[index].total = lineTotal
        let tax = Object.keys( this.lines[index].tax); //kdv oiv
        tax.forEach((tax) => {
            this.lines[index].tax[tax].amount = ((lineTotal /100) * parseFloat(this.lines[index].tax[tax].range))
        });
        this.toplam()
    },
    toplam(){
        let araToplam = 0;
        let grossTotal = 0;
        let tax = '';
        let taxes = [];

        this.lines.map((e) => {
            araToplam += parseFloat(e.total)
            tax = Object.keys( e.tax ); //kdv oiv
            tax.forEach((taxed) => {
                if(taxes && taxes.length > 0){
                    taxes.map((f,index)=>{
                        if(f.key == taxed && f.range == e.tax[taxed].range){
                            grossTotal = parseFloat(f.total) +  parseFloat(e.tax[taxed].amount)
                            taxes[index].total = parseFloat(f.total) +  parseFloat(e.tax[taxed].amount)
                        }else{
                            grossTotal = parseFloat(e.tax[taxed].amount)
                            taxes.push({ key:taxed , range: e.tax[taxed].range, total: parseFloat(e.tax[taxed].amount)}) 
                        }
                    })
                }else{
                    grossTotal = parseFloat(e.tax[taxed].amount)
                    taxes.push({ key:taxed , range: e.tax[taxed].range, total: parseFloat(e.tax[taxed].amount)})
                }
            });
            
        })
        // eslint-disable-next-line no-console
        grossTotal +=araToplam
        this.total = { araToplam,taxes,grossTotal}
    }
  },
};
</script>

<template>
<Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                <form @submit.prevent="handleSubmit">
                    <div class="row">
                        <div class="col-3">
                            <div class="mb-3">
                                <label for="name">Düzenlenme Tarihi</label>
                                <input
                                    id="date"
                                    v-model="form.date"
                                    type="date"
                                    class="form-control"
                                    placeholder="Tarih"
                                    :class="{
                                    'is-invalid': submitted && $v.form.date.$error,
                                    }"
                                />
                                <div
                                v-if="submitted && !$v.form.date.required"
                                class="invalid-feedback"
                            >
                            Bu alanı doldurmak zorunludur.
                            </div>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="mb-3">
                            <label for="serial">Seri No</label>
                            <input
                                id="serial"
                                v-model="form.serial"
                                type="text"
                                class="form-control"
                                placeholder="Seri No"
                                :class="{
                                'is-invalid': submitted && $v.form.serial.$error,
                                }"
                            />
                            <div
                                v-if="submitted && !$v.form.serial.required"
                                class="invalid-feedback"
                            >
                            Bu alanı doldurmak zorunludur.
                            </div>
                            </div>
                        </div>
                    </div>
                     <div class="row">
                        <div class="col-3">
                            <div class="mb-3">
                                <label for="cari">Cari</label>
                                 <v-select
                                    label="title" 
                                    v-model="form.type"
                                    :options="cariList" 
                                    :reduce="df => df.id">
                                <span slot="no-options">Sonuç Bulunamadı</span>
                                </v-select>
                                <div
                                v-if="submitted && !$v.form.date.required"
                                class="invalid-feedback"
                            >
                            Bu alanı doldurmak zorunludur.
                            </div>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="mb-3">
                            <label for="serial">Telefon</label>
                            <div>-</div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mb-3">
                            <label for="serial">Adres</label>
                            <div>-</div>
                            </div>
                        </div>
                    </div>
                    </form>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table mb-0 table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Hizmet/Ürün</th>
                                    <th>B. Fiyat</th>
                                    <th>Miktar</th>
                                    <th>Vergi</th>
                                    <th>Satır Toplamı</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr 
                                    v-for="(line,i) in lines"
                                    :key=i
                                >
                                    <th scope="row">{{ i+1 }}</th>
                                    <td style="width:40%">
                                        <input
                                            v-model="line.name"
                                            type="text"
                                            class="form-control form-control-sm"
                                            :class="{
                                                'is-invalid': lines[i].name.length < 1
                                             }"
                                            />
                                    </td>
                                   <td>
                                        <input
                                            v-model="line.amount"
                                            @input="calc(i)"
                                            type="text"
                                            class="form-control form-control-sm"
                                        />
                                    </td>
                                    <td>
                                        <input
                                            v-model="line.unit"
                                            @input="calc(i)"
                                            type="text"
                                            class="form-control form-control-sm"
                                        />
                                    </td>
                                    <td style="width:15%">
                                        <div class="input-group input-group-sm mb-3">
                                            <label class="input-group-text" for="kdv">KDV</label>
                                            <input type="text" v-model="line.tax.kdv.range" class="form-control form-control-sm" id="kdv">
                                            <label class="input-group-text" for="kdv">%</label>
                                        </div>
                                        <div style="border:solid 1px #00000038;border-radius:3px">
                                            <span @click="removeTax('oiv',i)" class="text-danger px-2" v-if="line.tax.oiv && line.tax.oiv.visible">Oiv Sil</span>
                                            <span @click="addTax('oiv',i)" v-else class="px-2">Oiv Ekle</span>
                                            <div class="input-group input-group-sm" v-if="line.tax.oiv && line.tax.oiv.visible">
                                                <label class="input-group-text" for="oiv">ÖİV</label>
                                                <input type="text" v-model="line.tax.oiv.range" class="form-control form-control-sm" id="oiv">
                                                <label class="input-group-text" for="oiv">%</label>
                                            </div>
                                        </div>
                                        
                                    </td>
                                    <td class="text-end">
                                       {{ line.total | fixed  }} TL
                                    </td>
                                    <td>
                                        <a 
                                        href="javascript:void(0);" 
                                        class="action-icon text-danger" 
                                        @click="removeLine(i)" 
                                        v-if="i >0"
                                        >
                                            <i class="mdi mdi-trash-can font-size-18"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <button class="btn btn-sm btn-warning" @click="newLine">Yeni Satır</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="offset-8 col-md-4">
                <div class="card">
                    <div class="card-body">
                    <div class="row mb-3">
                        <div class="table-responsive">
                            <table class="table mb-0 table-borderless">
                                <tbody>
                                    <tr>
                                        <th>Ara Toplam</th>
                                        <td class="text-end">{{ total.araToplam | fixed  }} TL</td>
                                    </tr>
                                    <tr v-for="(tax,i) in total.taxes" :key="i">
                                        <th>Toplam {{ tax.key.toUpperCase() }} ( {{ tax.range }} %)</th>
                                        <td class="text-end">{{ tax.total | fixed  }} TL</td>
                                    </tr>
                                    <tr>
                                        <th>GENEL TOPLAM</th>
                                        <td class="text-end">{{ total.grossTotal | fixed }} TL</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> 
                    <button class="btn btn-success">Kaydet</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </Layout>
</template>